// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"K2iOKQQMRnEnpSsycSCh","activeBreadcrumb":"tVA21uxZNkkDpnbdmiJd","disabled":"fP9X6w42hfsPbAaIypRr"};